/* eslint-disable no-console */
/* eslint-disable react/no-unknown-property */
/**
 * 公共 Portal App
 */

import { COOKIE_CATEGORIES, CookieChecker } from '@tencent/qcloud-intl-cookie-tool';
import Head from 'next/head';
import Script from 'next/script';
import { Google } from 'portal-common-account';
import { useEffect, useState } from 'react';

import { NEW_CDN_DOMAIN } from '../../constants';
// import commonConfig from '../../config/commonConfig';
import { Meta } from '../../constants/meta';
import { corsEnableForCDN } from '../../helpers/utils';
// import handleCDNFallback from '../../helpers/CDNFallback/handleCDNFallback';
import { logAnalysis } from '../LogAnalysis';
import { TAMMonitor } from '../TAMMonitor';

const asyncScripts = [
  `//${NEW_CDN_DOMAIN}/ecache/qcstat/qcloud/qcloudStatApi.js`,
  `//${NEW_CDN_DOMAIN}/qcloud/intl/statics/js/record-behavior.min.js`,
];

export default function CommonApp({ children, lang, title, keywords, description, showLayout = true }) {
  const { DEFAULT_TITLE, DEFAULT_KEYWORDS, DEFAULT_DESCRIPTION } = Meta;
  const [canUseAnalytics, setCanUseAnalytics] = useState(false);

  // handleCDNFallback(commonConfig.accessibleCheck);

  useEffect(() => {
    (async function asyncGetCanUseAnalytics() {
      // 获取某类Cookie是否能够使用。例如：分析类cookie
      // canIUseCookie 内部会调用 getRegionType 进行初始化，所以无需重复调用 init()
      const canUseAnalytics = await CookieChecker.canIUseCookie(COOKIE_CATEGORIES.analytics);
      if (canUseAnalytics) {
        logAnalysis();
        setCanUseAnalytics(true);
      }
    }());
  }, []);

  return (
    <TAMMonitor>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1, viewport-fit=cover" />

        <title>{title || DEFAULT_TITLE}</title>
        <meta name="keywords" content={typeof keywords === 'string' ? keywords : DEFAULT_KEYWORDS} />
        <meta name="description" content={typeof description === 'string' ? description : DEFAULT_DESCRIPTION} />
        {/* 预加载导航脚本，提升性能 */}
        {showLayout && <link rel="preload" href={`/qccomponent/resources/loader.js?lang=${lang}`} as="script" />}
        <link rel="dns-prefetch" href={`https://${NEW_CDN_DOMAIN}`} />
      </Head>
      {/* 谷歌提示快捷登录 */}
      <Google.OneClickLogin />

      {showLayout && (
        <>
          <Script>
            {`window.$qccomponent = {
                header: {
                  isNeedFix: true,
                },
              };
            `}
          </Script>
          <Script
            strategy="afterInteractive"
            id="qccomponent-loader"
            src={`/qccomponent/resources/loader.js?lang=${lang}`}
          />
        </>
      )}

      {/* {showLayout ? <Layout>{children}</Layout> : children} */}

      {children}

      {canUseAnalytics
        && asyncScripts.map((item, index) => (
          <Script
            async
            {...corsEnableForCDN(item)}
            src={item}
            key={`commonapp-script-async-${index}`}
            type="text/javascript"
          />
        ))}
    </TAMMonitor>
  );
}
